import Vue from 'vue'

/**
 * Limit Strings to n length
 * @name Limit string to n characters
 * @returns {string} String with the max of n characters
 */

const limitTo = (str, length) => {
  return str.substring(0, length)
}

Vue.filter('limitTo', limitTo)

export default limitTo
